import RefreshIcon from '@mui/icons-material/Refresh';
import {
    Card,
    CardContent,
    IconButton,
    Theme,
    Typography,
    useMediaQuery
} from '@mui/material';
import {
    Datagrid,
    DateField,
    List,
    useListContext,
    useRecordContext,
    useTranslate
} from 'react-admin';
import { MultilineTextField } from '../components';
import ListPagination from '../components/ListPagination';

const ListActions = () => {
    const { refetch, isFetching } = useListContext();
    const translate = useTranslate();

    return (
        <IconButton
            onClick={() => refetch()}
            disabled={isFetching}
            aria-label={translate('Atualizar')}
            size="small"
            sx={{ mr: 1 }}
        >
            <RefreshIcon />
        </IconButton>
    );
};

export const FillinLogsTab = () => {
    const record = useRecordContext();
    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                    Logs da AWS
                </Typography>

                <List
                    resource="fillins/logs"
                    filter={{ fillinId: record.id }}
                    pagination={<ListPagination />}
                    actions={<ListActions />}
                    disableSyncWithLocation
                >
                    <Datagrid
                        bulkActionButtons={false}
                        sx={{
                            '& .RaDatagrid-rowCell': {
                                paddingTop: 1,
                                paddingBottom: 1
                            }
                        }}
                    >
                        <DateField
                            source="@timestamp"
                            label="Data"
                            showTime
                            sx={{ minWidth: isSmall ? 100 : 180 }}
                        />
                        <MultilineTextField
                            source="@message"
                            label="Mensagem"
                            sx={{ width: '100%' }}
                        />
                    </Datagrid>
                </List>
            </CardContent>
        </Card>
    );
};